module.exports = __webpack_public_path__ + "static/media/hall-bg.28267f6b.webp";